import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@material-tailwind/react";
import { Toaster } from "react-hot-toast";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import "./index.css";
import PortalLayout from "./layouts/PortalLayout";
import { PortalAuthProvider } from "./context/PortalAuthContext";
import PortalCitasIndex from "./pages/PortalCitasIndex";
import PortalRevistas from "./pages/PortalRevistas";
import PortalRevistasBaja from "./pages/PortalRevistasBaja";
import PortalRevistaLector from "./pages/PortalRevistaLector";
import PortalLogin from "./pages/PortalLogin";
import PortalRegister from "./pages/PortalRegister";
import PortalForgotPassword from "./pages/PortalForgotPassword";
import PortalResetPassword from "./pages/PortalResetPassword";
import PortalClientPanel from "./pages/PortalClientPanel";
import PortalBookAppointment from "./pages/PortalBookAppointment";
import PortalMyAppointments from "./pages/PortalMyAppointments";
import PortalClientProfile from "./pages/PortalClientProfile";
import PortalAdminHome from "./pages/PortalAdminHome";
import PortalAdminNewPsych from "./pages/PortalAdminNewPsych";
import PortalAdminNewClient from "./pages/PortalAdminNewClient";
import PortalAdminPsychSchedule from "./pages/PortalAdminPsychSchedule";
import PortalAdminRevistaNuevo from "./pages/PortalAdminRevistaNuevo";
import PortalAdminRevistaIssue from "./pages/PortalAdminRevistaIssue";
import PortalPsychologistHome from "./pages/PortalPsychologistHome";
import PortalPsychologistProfile from "./pages/PortalPsychologistProfile";
import PortalPsychologistAppointments from "./pages/PortalPsychologistAppointments";
import PortalPsychologistCalendar from "./pages/PortalPsychologistCalendar";

const router = createBrowserRouter([
  // Lector a pantalla completa — sin PortalLayout (nav/footer)
  { path: "/revistas/leer", element: <PortalRevistaLector /> },
  {
    path: "/",
    element: <PortalLayout />,
    children: [
      { index: true, element: <PortalCitasIndex /> },
      { path: "revistas", element: <PortalRevistas /> },
      { path: "revistas/baja", element: <PortalRevistasBaja /> },
      { path: "login", element: <PortalLogin /> },
      { path: "register", element: <PortalRegister /> },
      { path: "forgot-password", element: <PortalForgotPassword /> },
      { path: "reset-password", element: <PortalResetPassword /> },
      // Legacy Spanish routes → redirect to English equivalents
      { path: "acceso", element: <Navigate to="/login" replace /> },
      { path: "registro", element: <Navigate to="/register" replace /> },
      { path: "recuperar-contrasena", element: <Navigate to="/forgot-password" replace /> },
      { path: "restablecer-contrasena", element: <Navigate to="/reset-password" replace /> },
      { path: "panel", element: <PortalClientPanel /> },
      { path: "agendar", element: <PortalBookAppointment /> },
      { path: "mis-citas", element: <PortalMyAppointments /> },
      { path: "mi-perfil", element: <PortalClientProfile /> },
      { path: "admin", element: <Navigate to="/admin/clientes" replace /> },
      { path: "admin/clientes", element: <PortalAdminHome /> },
      { path: "admin/psicologos", element: <PortalAdminHome /> },
      { path: "admin/citas", element: <PortalAdminHome /> },
      { path: "admin/revistas", element: <PortalAdminHome /> },
      { path: "admin/revistas/nuevo", element: <PortalAdminRevistaNuevo /> },
      { path: "admin/revistas/:issueId", element: <PortalAdminRevistaIssue /> },
      { path: "admin/clientes/nuevo", element: <PortalAdminNewClient /> },
      { path: "admin/psicologos/nuevo", element: <PortalAdminNewPsych /> },
      {
        path: "admin/psicologos/:psychologistId/horario",
        element: <PortalAdminPsychSchedule />,
      },
      { path: "psicologo", element: <PortalPsychologistHome /> },
      { path: "psicologo/perfil", element: <PortalPsychologistProfile /> },
      { path: "psicologo/citas", element: <PortalPsychologistAppointments /> },
      { path: "psicologo/calendario", element: <PortalPsychologistCalendar /> },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <PortalAuthProvider>
        <Toaster
          position="top-center"
          containerClassName="!top-20"
          toastOptions={{
            duration: 4200,
            style: {
              background: "rgb(27, 35, 49)",
              color: "rgb(255, 255, 255)",
              fontSize: "0.9rem",
            },
            success: {
              iconTheme: { primary: "brand-lavender", secondary: "#fff" },
            },
            error: {
              iconTheme: { primary: "#f87171", secondary: "#fff" },
            },
          }}
        />
        <RouterProvider router={router} />
      </PortalAuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
